import { name } from './name';
import { created } from './created';
import { namespace } from './namespace';

export const columns = [name, namespace, created];
